// Redux
import { combineReducers } from 'redux'

// Redux Persist
import createWebStorage from 'redux-persist/es/storage/createWebStorage'

// Slices
import applicationsSlice from './slices/applications.slice'
import authSlice from './slices/auth.slice'
import creditNotesSlice from './slices/credit-notes.slice'
import dayworksSlice from './slices/dayworks.slice'
import deliveryNotesSlice from './slices/delivery-notes.slice'
import directCostsSlice from './slices/direct-costs.slice'
import goodsReturnSlice from './slices/goods-return-notes.slice'
import invoiceSlice from './slices/invoices.slice'
import invoiceCheckingSlice from './slices/invoice-checkings.slice'
import paymentNoticesSlice from './slices/payment-notices.slice'
import projectSlice from './slices/projects.slice'
import purchaseOrdersSlice from './slices/purchase-orders.slice'
import salesCreditNoteSlice from './slices/sales-credit-notes.slice'
import settingsSlice from './slices/settings.slice'
import timeSheetSlice from './slices/time-sheets.slice'
import variationsSlice from './slices/variations.slice'
import viewSlice from './slices/viewSlice'
import projectTypesSlice from './slices/project-types.slice'

import localforage from 'localforage'

const createNoopStorage = () => {
  return {
    getItem(_key: string) {
      return Promise.resolve(null)
    },
    setItem(_key: string, value: string) {
      return Promise.resolve(value)
    },
    removeItem(_key: string) {
      return Promise.resolve()
    },
  }
}

export const config = {
  key: 'root',
  storage: localforage,
  keyPrefix: 'commander-',
}

export const rootReducer = combineReducers({
  applications: applicationsSlice,
  auth: authSlice,
  creditNotes: creditNotesSlice,
  dayworks: dayworksSlice,
  deliveryNotes: deliveryNotesSlice,
  directCosts: directCostsSlice,
  goodsReturnNotes: goodsReturnSlice,
  invoices: invoiceSlice,
  invoiceChecking: invoiceCheckingSlice,
  paymentNotices: paymentNoticesSlice,
  purchaseOrders: purchaseOrdersSlice,
  project: projectSlice,
  salesCreditNotes: salesCreditNoteSlice,
  settings: settingsSlice,
  timeSheets: timeSheetSlice,
  variations: variationsSlice,
  view: viewSlice,
  projectTypes: projectTypesSlice,
})
